import { getSpaceSlugPathQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy single-lesson URL. Redirects to the slug program home `/programs/{program}`,
 * which renders the single lesson directly.
 */
export const Route = createFileRoute('/_protected/community-hub/spaces/$id/lesson/')({
  beforeLoad: async ({ params }) => {
    const path = await queryClient.ensureQueryData(getSpaceSlugPathQueryOptions(params.id));
    throw redirect({ to: '/programs/$programSlug', params: { programSlug: path.programSlug }, replace: true });
  },
});
